import {
  AUTHENTICATE_USER,
  CHECK_USER_LOGGED_IN,
  setLoaderModal,
  setErrorToastMessage,
  setUserAuthenticated,
  setReplayOnAuthentication,
  LOGOUT_USER
} from "../actions";
import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  authenticateUser,
  checkLoggedIn,
  logout
} from "../../../api/common/user";

export function* authUserTask(action) {
  try {
    yield put(setLoaderModal(true));
    const { data } = yield call(authenticateUser, action.payload);
    yield put(setUserAuthenticated(data.success));
    yield put(setLoaderModal(false));
    const replayAction = yield select(
      ({ geofence }) => geofence.replayActionOnAuthentication
    );
    if (replayAction.length > 0) {
      yield put(setReplayOnAuthentication(null));
      for (let i = 0; i < replayAction.length; i++) {
        yield put(replayAction[i]);
      }
    }
  } catch (e) {
    yield put(setLoaderModal(false));
    console.error(e);
    console.error(e.response.data.message);
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchAuthUserAction() {
  yield takeLatest(AUTHENTICATE_USER, authUserTask);
}

export function* checkUserTask(action) {
  try {
    yield put(setLoaderModal(true));
    yield call(checkLoggedIn);
    yield put(setUserAuthenticated(true));
    yield put(setLoaderModal(false));
  } catch (e) {
    yield put(setUserAuthenticated(false));
    yield put(setLoaderModal(false));
    console.error(e);
    console.error(e.response.data.message);
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchCheckUserLoggedInAction() {
  yield takeLatest(CHECK_USER_LOGGED_IN, checkUserTask);
}

export function* logoutUserTask(action) {
  try {
    yield put(setLoaderModal(true));
    yield call(logout, action.payload);
    yield put(setUserAuthenticated(false));
    yield put(setLoaderModal(false));
    window.location.replace("/");
  } catch (e) {
    yield put(setLoaderModal(false));
    console.error(e);
    console.error(e.response.data.message);
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* logoutUserActionWatcher() {
  yield takeLatest(LOGOUT_USER, logoutUserTask);
}
